export function TypingIndicator() {
  return (
    <div role="status" aria-label="Bot is typing" class="flex items-center gap-1 px-4 py-3">
      <div class="typing-dot" style="animation-delay: 0ms" />
      <div class="typing-dot" style="animation-delay: 150ms" />
      <div class="typing-dot" style="animation-delay: 300ms" />
    </div>
  );
}
